<div class="center" style="max-width:1000px">
  <div class="freeze_height" *ngIf="pageKey != 0">
    <a class="button" [routerLink]="['/pagekeys' + localService.basicParamsString,1,0]"><i class="material-icons button icon_adjust" style="top:5px">north</i></a>
    <span>&nbsp;</span>
    <span>{{strPageKey}}</span>
    <span>&nbsp;</span>
    <a class="button" *ngIf="accessRole != 0" [routerLink]="['/allowed-actions' + localService.basicParamsString,pageKey,0]"><i class="material-icons button icon_adjust" style="top:5px">security</i></a>
    <a class="button" *ngIf="accessRole == 0" [routerLink]="['/pagekeys' + localService.basicParamsString,2,pageKey]"><i class="material-icons button icon_adjust" style="top:5px">account_tree</i></a>
    <span *ngIf="accessRole != 0">&nbsp;/&nbsp;</span>
    <a class="button" *ngIf="accessRole != 0" [routerLink]="['/pagekeys' + localService.basicParamsString,2,pageKey]"><i class="material-icons button icon_adjust" style="top:5px">north</i></a>
    <span>&nbsp;</span>
    <span *ngIf="accessRole != 0">{{strAccessRole}}</span>
  </div>
  <app-left-right-selection *ngIf="wrapper" [wrapper]="wrapper" (onSelectionUpdated)="onSave($event)"></app-left-right-selection>
</div>
